import { Grid } from '@mui/material';
import * as Yup from 'yup';
import { useMemo } from 'react';
import SearchRemover from 'components/search-field/search-remover';
import SearchField from 'components/search-field/search-field.container';
import { SearchJsonObject } from 'components/search-field/search.form';
import { useGetTicketGatewaysQuery } from 'app/store';
import TicketGatewayOption from './ticket-gateway-option';

const TicketSearch = ({ search, onSearch, onPage }: any) => {
    const { data: ticketGateways = [], isFetching } =
        useGetTicketGatewaysQuery(undefined, {
            refetchOnMountOrArgChange: true,
        });

    const searchJson = useMemo<SearchJsonObject>(
        () => ({
            fields: [
                {
                    name: 'id',
                    label: 'شناسه',
                    component: 'Text',
                    ltr: 'true',
                    icon: <i className="fas fa-hashtag"></i>,
                },
                {
                    name: 'title',
                    label: 'موضوع',
                    component: 'Text',
                    maxLength: 64,
                    icon: <i className="fa-light fa-text"></i>,
                },
                {
                    name: 'gateway_id',
                    label: 'درگاه',
                    component: 'Select',
                    disabled: isFetching,
                    icon: <i className="fa-light fa-credit-card"></i>,
                    options: ticketGateways.map((gateway) => ({
                        label: <TicketGatewayOption gateway={gateway} />,
                        value: gateway.id,
                    })),
                },
                {
                    name: 'department',
                    label: 'دپارتمان',
                    component: 'Select',
                    icon: <i className="fa-light fa-id-card"></i>,
                    options: [
                        { label: 'تایید یا تغییر اطلاعات', value: 'info_change' },
                        { label: 'موارد فنی', value: 'technical' },
                        { label: 'موارد مالی و مغایرت', value: 'financial' },
                        { label: 'درخواست درگاه پرداخت', value: 'gateway_request' },
                        { label: 'احراز هویت', value: 'authentication' },
                        { label: 'پیگیری تراکنش', value: 'transaction_tracking' },
                        { label: 'گزارش تخلف پذیرنده', value: 'merchant_violation' },
                        { label: 'حقوقی و پیگیری قضایی', value: 'legal' },
                        { label: 'پیشنهاد، انتقاد و شکایت', value: 'comment' },
                    ],
                },
                {
                    name: 'status',
                    label: 'وضعیت',
                    component: 'Select',
                    icon: <i className="fa-light fa-id-card"></i>,
                    options: [
                        { label: 'درحال بررسی', value: 'pending' },
                        { label: 'تیکت جدید', value: 'adminCreated' },
                        { label: 'در انتظار پاسخ', value: 'waiting' },
                        { label: 'پاسخ داده شده', value: 'answered' },
                        { label: 'بسته شده', value: 'closed' },
                    ],
                },
            ],
            validation: Yup.object().shape({
                title: Yup.string()
                    .nullable()
                    .min(3, 'فیلد موضوع تیکت باید حداقل 3 کاراکتر باشد')
                    .max(64, 'فیلد موضوع تیکت باید حداکثر 64 کاراکتر باشد'),
                id: Yup.number()
                    .nullable()
                    .typeError('فیلد شناسه باید یک عدد باشد')
                    .integer('شناسه باید عدد صحیح باشد')
                    .min(1, 'شناسه باید بزرگتر از صفر باشد'),
            }),
        }),
        [isFetching, ticketGateways],
    );

    return (
        <>
            {Object.keys(search)?.length > 0 && (
                <Grid item sx={{ pt: '0px !important' }}>
                    <SearchRemover onSearch={onSearch} defaultValue={{}} />
                </Grid>
            )}

            <Grid item sx={{ pt: '0px !important' }}>
                <SearchField
                    searchJson={searchJson}
                    search={search}
                    setSearch={onSearch}
                    setPage={onPage}
                    label="تیکت ها"
                />
            </Grid>
        </>
    );
};

export default TicketSearch;
